import {Row} from "antd";
import styled from "styled-components";

export const OrderInformationContainer = styled(Row)`
    width: 100%;
    padding: 20px 0;
    margin-bottom: 20px;
    border-bottom: 1px dashed #c6c5c5;
`;

// Customer-specific compact order information container
export const CustomerOrderInformationContainer = styled(Row)`
    width: 100%;
    padding: 8px 0;
    margin-bottom: 6px;
    border-bottom: 1px dashed #c6c5c5;
`;
